function get(modelAttributeName) {
    if (!modelAttributeName) {
        return null;
    }
    const model = window.modelContainer[modelAttributeName];

    if (model === null || model === undefined) {
        return null;
    }
    return model;
}

function resolve(modelAttributeName) {
    if(!modelAttributeName) {
        return Promise.reject({stack: "couldn't resolve content from model container"});
    }
    const value = window.modelContainer[modelAttributeName];
    if(value === null || value === undefined) {
        return Promise.reject({stack: "couldn't resolve content from model container"})
    }
    return Promise.resolve(value);
}

export default {
    get,
    resolve
};